<template>
  <div class="asc-menu-list">
    <v-list :dense="dense" :style="{ width: width + 'px' }">
      <template v-for="(item, i) in primaryItems">
        <div v-if="item.isText" :key="i">
          <asc-label
            :value="item.text"
            :size="item.size"
            :color="item.color"
            :uppercase="item.uppercase"
            :class="[
              'asc-menu-list--text',
              item.topPadding ? 'asc-menu-list--top-padding' : '',
              item.bottomPadding ? 'asc-menu-list--bottom-padding' : '',
            ]"
          ></asc-label>
        </div>
        <v-divider v-if="item.isSeparator" :key="i"></v-divider>
        <v-list-item
          v-if="item.to"
          :key="i"
          :to="item.to"
          :disabled="item.disabled"
        >
          <v-list-item-title :title="item.title">
            {{ item.title }}
          </v-list-item-title>
        </v-list-item>
        <v-list-item
          v-if="item.href"
          :key="i"
          :href="item.href"
          :target="item.target"
          :rel="item.rel"
          :disabled="item.disabled"
        >
          <v-list-item-title :title="item.title">
            {{ item.title }}
            <template v-if="item.icon">
              <v-icon size="15">{{ item.icon }}</v-icon>
            </template>
          </v-list-item-title>
        </v-list-item>
        <v-list-item
          v-if="item.onClick"
          :key="i"
          class="asc-menu-list--item"
          :disabled="item.disabled"
          @click="item.onClick"
        >
          <v-list-item-title>{{ item.title }}</v-list-item-title>
        </v-list-item>
        <v-list-item
          v-if="item.isMenuItem"
          :key="i"
          class="asc-menu-list--item"
          :disabled="item.disabled"
          @click="handleMenuSelection(item.title)"
        >
          <v-list-item-title>{{ item.title }}</v-list-item-title>
        </v-list-item>
      </template>
    </v-list>
    <template v-if="secondaryItems.length > 0">
      <v-list :dense="dense" :style="{ width: width + 'px' }">
        <template v-for="(item, i) in secondaryItems">
          <v-divider v-if="item.isSeparator" :key="i"></v-divider>
          <v-list-item
            v-if="!item.isSeparator"
            :key="i"
            :to="item.to"
            :disabled="item.disabled"
          >
            <v-list-item-title :title="item.title">
              {{ item.title }}
            </v-list-item-title>
          </v-list-item>
        </template>
      </v-list>
    </template>
  </div>
</template>

<script>
import AscLabel from '@/components/atoms/AscLabel'
export default {
  name: 'AscMenuList',

  components: {
    AscLabel,
  },

  props: {
    primaryItems: {
      type: Array,
      default: () => [],
    },
    secondaryItems: {
      type: Array,
      default: () => [],
    },
    dense: {
      type: Boolean,
      default: false,
    },
    width: {
      type: Number,
      default: 200,
    },
  },
  methods: {
    handleMenuSelection(item) {
      this.$emit('menuSelection', item)
    },
  },
}
</script>

<style lang="scss">
.v-menu__content {
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.3) !important;
  margin-top: 2px;
  border-radius: 2px;
}

.asc-menu-list {
  max-height: 450px;
  overflow-x: hidden;

  &--text {
    padding-left: 12px;
    display: block;
  }

  &--top-padding {
    padding-top: 8px;
  }

  &--bottom-padding {
    padding-bottom: 8px;
  }

  .v-list--dense {
    max-height: 400px !important;
    overflow-x: auto;
    padding-bottom: 0;
  }

  .v-list--dense .v-list-item:not(.v-list-item--avatar) {
    min-height: 30px !important;

    .v-list-item__title,
    .v-list-item__subtitle {
      font-size: $font-size-md;
    }
  }

  .v-list > div {
    background-color: $primary-white;
  }

  .v-list-item--link {
    color: inherit;
    font-size: 14px;
  }

  .v-list {
    max-height: 365px;
    width: 350px;
  }

  .asc-menu-list--item {
    & > .v-list-item:hover {
      text-decoration: none;
    }
  }
}
</style>
